import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiStar } = FiIcons;

const reviews = [
  { name: "Sarah M.", loc: "Parramatta NSW", biz: "Accounting Practice Owner", text: "The local SEO optimization has us ranking #1 for 'accountant Parramatta'. We're finally getting enquiries from the exact client profile we want." },
  { name: "Michael R.", loc: "Toowoomba QLD", biz: "Mortgage Broker", text: "Clients tell us they chose us because our website made us look more established than the bigger firms. It's built immediate trust." },
  { name: "Priya K.", loc: "Glen Waverley VIC", biz: "Psychology Clinic Director", text: "The conversion rate from website visitors to phone consultations has doubled. The authority-first layout really resonates with our clients." },
  { name: "David L.", loc: "Perth WA", biz: "Commercial Lawyer", text: "Finally, a digital presence that matches the quality of our legal advice. It positions us as the obvious expert choice." },
  { name: "Emma T.", loc: "Brisbane QLD", biz: "Financial Planner", text: "The glassmorphic design is stunning, but more importantly, it conveys the premium nature of our wealth management services." },
  { name: "James H.", loc: "Adelaide SA", biz: "Business Consultant", text: "We've seen a 40% increase in high-value enquiries since launching our authority page. It's been our best marketing investment." },
  { name: "Lisa C.", loc: "Canberra ACT", biz: "Allied Health Practice", text: "The process was professional and the results speak for themselves. Our local authority has never been stronger." },
  { name: "Robert K.", loc: "Gold Coast QLD", biz: "Tax Specialist", text: "I was skeptical about landing pages for tax, but the psychology behind this layout works. Prospects call pre-sold on our expertise." },
  { name: "Nadia S.", loc: "Sydney NSW", biz: "Boutique Agency", text: "The authority page has allowed us to increase our rates because the digital presentation now supports our premium positioning." },
  { name: "Mark W.", loc: "Melbourne VIC", biz: "Education Provider", text: "The local SEO architecture is brilliant. We're capturing demand exactly when and where people are searching for our courses." }
];

const Reviews = () => {
  return (
    <div className="overflow-hidden">
      <h2 className="text-4xl font-bold text-white font-display mb-16 text-center">Trusted by Australian Professionals</h2>
      <div className="flex gap-6 w-max animate-scroll">
        {[...reviews, ...reviews].map((r, i) => (
          <div key={i} className="glass-card p-8 w-[350px] flex-shrink-0">
            <div className="flex gap-1 mb-4">
              {[...Array(5)].map((_, j) => (
                <SafeIcon key={j} icon={FiStar} className="text-blue-500 fill-blue-500/20 text-sm" />
              ))}
            </div>
            <p className="text-slate-300 text-sm leading-relaxed mb-6 italic">"{r.text}"</p>
            <div>
              <div className="text-white font-bold">{r.name}</div>
              <div className="text-slate-500 text-xs">{r.loc} &bull; {r.biz}</div>
            </div>
          </div>
        ))}
      </div>
      <style>{`
        @keyframes scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-scroll {
          animation: scroll 40s linear infinite;
        }
        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
    </div>
  );
};

export default Reviews;